/** MI DOMINO - daily gift: once per calendar day, PhilCoins that grow with your
 *  login streak (50 → +10/day, capped at 150). Keeps players coming back. */
import { saveWallet } from './tienda';
import { updateCoinBal } from './wallet';
import { WALLET } from '../state';
import { LANG } from '../ui/i18n';
import { toast } from '../ui/toast';

export function checkDailyReward(): void {
  let last = '', streak = 0;
  try { last = localStorage.getItem('mddaily') || ''; streak = parseInt(localStorage.getItem('mddailystreak') || '0', 10) || 0; } catch (e) { /* */ }
  const now = new Date();
  const today = now.toISOString().slice(0, 10);
  if (last === today) return;                       // already claimed today
  const y = new Date(now); y.setDate(y.getDate() - 1);
  streak = (last === y.toISOString().slice(0, 10)) ? streak + 1 : 1;   // consecutive?
  try { localStorage.setItem('mddaily', today); localStorage.setItem('mddailystreak', String(streak)); } catch (e) { /* */ }
  const amt = Math.min(50 + (streak - 1) * 10, 150);
  WALLET.coins += amt; saveWallet(); updateCoinBal();
  const en = LANG === 'en';
  setTimeout(() => toast(`🎁 ${en ? 'Daily gift' : 'Regalo diario'} · ${en ? 'day' : 'día'} ${streak}: +${amt} 🪙`), 700);
}
